import { type FC } from 'react';
import DeviceConfigurationModal from './DeviceConfigurationModal';
import DeviceAliasModal from './aliasModal/DeviceAliasModal';
import CloneDeviceModal from './cloneDeviceModal/CloneDeviceModal';
import DeviceMainMetricModal from '../../homeAmaru/components/mainMetricModal/DeviceMainMetricModal';

const DeviceConfigurationGlobalModals: FC = () => {
  return (
    <>
      <DeviceConfigurationModal />
      <DeviceAliasModal />
      <CloneDeviceModal />
      <DeviceMainMetricModal />
    </>
  );
};

export default DeviceConfigurationGlobalModals;
